import type { TFunction } from "i18next";

import { ANM_CATALOG_TEMPLATE } from "./anm-classification.catalog-template";
import type { SectionDef } from "./anm-classification.catalog.types";

const CATALOG_PREFIX = "admin.structures.anmClassification.catalog";

const catalogKey = (relativeKey: string) => `${CATALOG_PREFIX}.${relativeKey}`;

export const buildAnmSections = (translate: TFunction): SectionDef[] =>
  ANM_CATALOG_TEMPLATE.map((section) => ({
    key: section.key,
    label: translate(catalogKey(section.labelKey)),
    subtitle: translate(catalogKey(section.subtitleKey)),
    hasBignumber: section.hasBignumber,
    grades: section.grades.map((grade) => ({
      key: grade.key,
      code: grade.code,
      fullTitle: translate(catalogKey(grade.fullTitleKey)),
      columns: grade.columns.map((column) => ({
        key: column.key,
        letter: column.letter,
        title: translate(catalogKey(column.titleKey)),
        options: column.options.map((option) => ({
          score: option.score,
          text: translate(catalogKey(option.textKey)),
        })),
      })),
    })),
  }));

export const getAllAnmColumnKeys = (): string[] =>
  ANM_CATALOG_TEMPLATE.flatMap((section) =>
    section.grades.flatMap((grade) => grade.columns.map((column) => column.key)),
  );

export const getAllAnmGradeKeys = (): string[] =>
  ANM_CATALOG_TEMPLATE.flatMap((section) => section.grades.map((grade) => grade.key));
